/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { AnagraficaFasiDTO } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const getBackAnagraficaFasi = (
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaFasiDTO[]>(
    {
      url: `/framework-bo-procedimenti/anagrafica-fasi`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackAnagraficaFasiQueryKey = () =>
  [`/framework-bo-procedimenti/anagrafica-fasi`] as const;

export const getGetBackAnagraficaFasiQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackAnagraficaFasi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAnagraficaFasi>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBackAnagraficaFasiQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAnagraficaFasi>>
  > = ({ signal }) => getBackAnagraficaFasi(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions };
};

export type GetBackAnagraficaFasiQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAnagraficaFasi>>
>;
export type GetBackAnagraficaFasiQueryError = ErrorType<unknown>;

export const useGetBackAnagraficaFasi = <
  TData = Awaited<ReturnType<typeof getBackAnagraficaFasi>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getBackAnagraficaFasi>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackAnagraficaFasiQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};

export const getBackAnagraficaFasiIstanzaProcedimentoId = (
  idIstanzaProcedimento: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<AnagraficaFasiDTO>(
    {
      url: `/framework-bo-procedimenti/anagrafica-fasi/istanza-procedimento/${idIstanzaProcedimento}`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackAnagraficaFasiIstanzaProcedimentoIdQueryKey = (
  idIstanzaProcedimento: string,
) =>
  [
    `/framework-bo-procedimenti/anagrafica-fasi/istanza-procedimento/${idIstanzaProcedimento}`,
  ] as const;

export const getGetBackAnagraficaFasiIstanzaProcedimentoIdQueryOptions = <
  TData = Awaited<
    ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackAnagraficaFasiIstanzaProcedimentoIdQueryKey(
      idIstanzaProcedimento,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>>
  > = ({ signal }) =>
    getBackAnagraficaFasiIstanzaProcedimentoId(
      idIstanzaProcedimento,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!idIstanzaProcedimento,
    ...queryOptions,
  };
};

export type GetBackAnagraficaFasiIstanzaProcedimentoIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>>
>;
export type GetBackAnagraficaFasiIstanzaProcedimentoIdQueryError =
  ErrorType<unknown>;

export const useGetBackAnagraficaFasiIstanzaProcedimentoId = <
  TData = Awaited<
    ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>
  >,
  TError = ErrorType<unknown>,
>(
  idIstanzaProcedimento: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAnagraficaFasiIstanzaProcedimentoId>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions =
    getGetBackAnagraficaFasiIstanzaProcedimentoIdQueryOptions(
      idIstanzaProcedimento,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
